export const Attivita_section1 = () => {
    return (
        <div>
            <h3><img src={"images/centroestivo/loghi/logo_sportmix2.png"} width="23%"/></h3><h3 className="shadowtext-1bl">Giochi di movimento, <br/> esercizi Ludico-Espressivi</h3>
            <br />
            <h3> <img src={"images/centroestivo/loghi/logo_detective.png"} width="25%"/> </h3><h3 className="shadowtext-1bl">Detective  Challenges</h3>
            <h6 className="new-badge align-center">NEW</h6>
            <br />
            <h3> <img src={"images/centroestivo/loghi/logo_vulci.png"} width="35%"/> </h3><h3 className="shadowtext-1bl">Escursioni naturalistiche</h3>
            <br />
        </div>
    )
}